export default __webpack_public_path__ + "static/media/b_stayingPositive_small.4d398f1b.png";